export const LIST_ACCOUNT_CREATE_BUILDING = process.env.ACCOUNT_CREATE_BUILDING?.split(',') || [];
export const LIST_ACCOUNT_CS = process.env.ACCOUNT_CS?.split(',') || [];
